export const SET_TABLE_FILTER = "SET_TABLE_FILTER";
